import { Sparkles } from "lucide-react";
import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import { titledBodyMarkdown } from "@/components/storyboard/text/utils/titledBodyMarkdown";
import type { TextTitledBodyData } from "@/types/storyboard";

interface Props {
  data: TextTitledBodyData;
}

export const TextSummary = ({ data }: Props) => {
  return (
    <ContentBlock icon={Sparkles} title={data.title} tone="emphasis">
      <div className="prose max-w-full text-primary">
        <CourseMarkdown>{titledBodyMarkdown(data)}</CourseMarkdown>
      </div>
    </ContentBlock>
  );
};
